import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

interface AiBudgetUserViewModel {
  userId: string;
  tokensUsed: number;
  chatMessagesToday: number;
  testsGeneratedToday: number;
  status: string;
}

interface AiBudgetStatusViewModel {
  globalTokensUsed: number;
  globalTokenLimit: number;
  usagePercentage: number;
  status: string;
  testGenerationRequestsToday: number;
  topUsers: AiBudgetUserViewModel[];
}

@Component({
  selector: 'app-ai-budget-status',
  templateUrl: './ai-budget-status.component.html',
  styleUrls: ['./ai-budget-status.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiBudgetStatusComponent {

  @Input() budgetStatus: AiBudgetStatusViewModel;

  trackByUserId(index: number, item: AiBudgetUserViewModel): string {
    return item ? item.userId : String(index);
  }

  get usageWidth(): number {
    const value = this.budgetStatus ? this.budgetStatus.usagePercentage : 0;
    return Math.max(0, Math.min(100, value || 0));
  }

  get statusClass(): string {
    return this.resolveStatusClass(this.normalizeStatus());
  }

  get statusKey(): string {
    return this.resolveStatusKey(this.normalizeStatus());
  }

  getUserStatusClass(status: string): string {
    return this.resolveStatusClass(this.normalizeStatusValue(status));
  }

  getUserStatusKey(status: string): string {
    return this.resolveStatusKey(this.normalizeStatusValue(status));
  }

  private resolveStatusClass(value: string): string {
    if (value === 'warning') {
      return 'ai-budget__status--warning';
    }
    if (value === 'critical') {
      return 'ai-budget__status--critical';
    }
    return 'ai-budget__status--normal';
  }

  private resolveStatusKey(value: string): string {
    if (value === 'warning') {
      return 'SKILL_LEARNING_AI_STATS_STATUS_WARNING';
    }
    if (value === 'critical') {
      return 'SKILL_LEARNING_AI_STATS_STATUS_CRITICAL';
    }
    return 'SKILL_LEARNING_AI_STATS_STATUS_NORMAL';
  }

  private normalizeStatus(): string {
    return this.normalizeStatusValue(this.budgetStatus ? this.budgetStatus.status : '');
  }

  private normalizeStatusValue(value: string): string {
    return value ? value.toLowerCase() : '';
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/ai-budget-status/ai-budget-status.component.ts